import {CLEAR_SESSION_EXPIRED, LOGIN_FAIL, LOGIN_PENDING, LOGIN_SUCCESS, LOGOUT, SESSION_EXPIRED} from "./types";
import api from "../../api/api";
import {message} from "antd";
import {STATE_URL} from "../../constants/urlConfig";

export const login = (credentials) => async (dispatch, getState) => {
    try {
        dispatch({type: LOGIN_PENDING});
        const {data} = await api.login(credentials);
        localStorage.setItem('vlmToken', data.jwtToken);
        const stateResp = await api.get(STATE_URL);
        const userData = stateResp.data;
        localStorage.setItem('vlmUserData', JSON.stringify(userData));
        dispatch({
            type: LOGIN_SUCCESS, payload: {
                user: data,
                userData: userData
            }
        });
    } catch (error) {
        console.error(error);
        const darkMode = getState().theme.darkMode;
        dispatch({type: LOGIN_FAIL});
        message.error({content:'Login failed. Please try again.',
            className: darkMode && "dark-mode"});
    }
};

export const logout = (callback) => async (dispatch) => {
    localStorage.removeItem('vlmToken');
    dispatch({type: LOGOUT});
    if (callback) callback();
};

export const expireSession = () => async dispatch => {
    dispatch(logout());

    dispatch({type: SESSION_EXPIRED});

    setTimeout(() => {
        dispatch({type: CLEAR_SESSION_EXPIRED})
    }, 5000)
};